import { Select as MuiSelect, selectClasses } from '@mui/material';
import React, { forwardRef, ReactNode, Ref, useRef } from 'react';
import { styled } from 'styled-components';

import { slotInputStyle } from '../../styledComponentStyle';

import { SlotWrapper, SlotWrapperProps } from './SlotWrapper';
import { useEnrollSlotRef } from './hooks';
import { SlotRef } from './types';

const StyledSelect = styled(MuiSelect)<{ $fullWidth?: boolean }>`
  ${slotInputStyle}

  &.MuiOutlinedInput-root {
    color: var(--HPACS_Text_Light_Grey, #a3a6ab);
    text-align: center;

    & fieldset {
      border: 1px solid var(--Hscan_light_grey, #e7e7e7);
    }
  }

  & .${selectClasses.select} {
    padding-top: 7px;
    padding-bottom: 7px;
    font-size: 14px;
    line-height: 24px;
  }
`;

interface SelectSlotProps extends SlotWrapperProps {
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  fullwidth?: boolean;
  endIcon?: ReactNode;
  children?: ReactNode;
}
export const SelectSlot = forwardRef(
  (
    {
      value,
      onChange,
      readOnly,
      fullwidth,
      endIcon,
      children,
      ...slotWrapperProps
    }: SelectSlotProps,
    ref: Ref<SlotRef>,
  ) => {
    const wrapperRef = useRef(null);
    const selectRef = useRef<{
      focus(): void;
      value: string;
      node: HTMLInputElement;
    }>(null);
    useEnrollSlotRef({ ref, wrapperRef, inputs: [selectRef.current] });

    return (
      <SlotWrapper ref={wrapperRef} {...slotWrapperProps}>
        <StyledSelect
          displayEmpty
          inputProps={{
            ref: selectRef,
          }}
          value={value}
          onChange={e => onChange?.(e.target.value as string)}
          readOnly={readOnly}
          $fullWidth={fullwidth}>
          {children}
        </StyledSelect>
        {endIcon}
      </SlotWrapper>
    );
  },
);
